export const namespace = 'windowFrame'
